<template>
  <div class="container mt-lg-5">

    <!-- Vista de Lista de Formularios -->
    <div class="d-flex flex-column gap-3">
      <div class="d-flex flex-column flex-md-row gap-3">
        <h2 class="fs-2 mb-0 flex-shrink-0">{{ $t('listaFormularios') }}</h2>
        <div class="d-flex align-items-center position-relative w-100 gap-2">
          <!-- Ícono SVG de lupa -->
          <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" class="position-absolute top-50 start-0 translate-middle-y ms-2 text-secondary" style="pointer-events: none">
            <path d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z" stroke="currentColor"  fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <input type="text" class="form-control m-0 rounded-3 borde-terciario fondo-terciario sombra" :placeholder="$t('buscarFormularios') + '...'" v-model="search"
            style="padding-left: 35px;"/>
          <button v-if="search" type="button" class="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent" @click="search = ''">
            <i class="bi bi-x text-secondary" style="font-size: 30px;"></i> <!-- Icono de "x" -->
          </button>
          <router-link v-if="crearFormPermiso" to="/formularios/crear" class="btn bg-goethe-accent sombra p-1 rounded-3 m-auto">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 12H18M12 6V18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
        </div>
      </div>

      <!-- Checkbox de todos los formularios -->
      <div class="d-flex gap-3 align-items-center justify-content-between">
        <div class="d-flex flex-wrap gap-2">
          <div class="position-relative">
            <!-- Ícono para abrir el menú de ordenación -->
            <i class="bi bi-filter fs-1 text-goethe-accent-claro fs-4" @click="showMenuFilter = !showMenuFilter" style="cursor: pointer;"></i>

            <!-- Fondo transparente para detectar clics fuera -->
            <div v-if="showMenuFilter" class="overlay" @click="showMenuFilter = false"></div>

            <div v-if="showMenuFilter" class="dropdown-menu show position-absolute bg-goethe-accent-claro-2 border-0 user-select-none px-2" aria-labelledby="dropdownMenuButton" style="top: 100%; left: 0; z-index: 1000; min-width: 180px;">
              <p class="m-0 fs-6 texto-principal">Ordenar por:</p>
              <div class="form-check d-flex align-items-center gap-1" style="cursor: pointer;">
                <input class="form-check-input" type="radio" id="sortTitulo" v-model="sortKey" value="Titulo" style="transform: scale(0.8);">
                <label class="form-check-label texto-principal" for="sortTitulo">Título</label>
              </div>
              <div class="form-check d-flex align-items-center gap-1" style="cursor: pointer;">
                <input class="form-check-input" type="radio" id="sortCreacion" v-model="sortKey" value="Creacion" style="transform: scale(0.8);">
                <label class="form-check-label texto-principal" for="sortCreacion">Fecha de Creación</label>
              </div>
              <div class="form-check d-flex align-items-center gap-1" style="cursor: pointer;">
                <input class="form-check-input" type="radio" id="sortUltMod" v-model="sortKey" value="UltMod" style="transform: scale(0.8);">
                <label class="form-check-label texto-principal" for="sortUltMod">Fecha de Modificación</label>
              </div>
              <div class="form-check d-flex align-items-center gap-1" style="cursor: pointer;">
                <input class="form-check-input" type="radio" id="sortCreadoPor" v-model="sortKey" value="CreadoPor" style="transform: scale(0.8);">
                <label class="form-check-label texto-principal" for="sortCreadoPor">Creador</label>
              </div>
            </div>
          </div>
          <div v-if="verTodosForms"
            class="form-check-pill"
            :class="{ 'checked': mostrarTodos }"
              @click="mostrarTodos = !mostrarTodos; fetchForms()">
            <span>{{ $t('todosLosFormularios') }}</span>
          </div>
          <div v-if="verTodosForms"
            class="form-check-pill"
            :class="{ 'checked': showDetails }"
              @click="showDetails = !showDetails">
            <span>{{ $t('mostrarDatosInternos') }}</span>
          </div>
          <div v-if="tieneAccesoEditor"
            class="form-check-pill"
            :class="{ 'checked': showEditor }"
              @click="showEditor = !showEditor, showLector= false , showCompletador= false">
            <span>{{ $t('editor') }}</span>
          </div>
          <div v-if="tieneAccesoLector"
            class="form-check-pill"
            :class="{ 'checked': showLector }"
              @click="showLector = !showLector, showCompletador= false , showEditor= false">
            <span>{{ $t('lector') }}</span>
          </div>
          <div v-if="tieneAccesoCompletador"
            class="form-check-pill"
            :class="{ 'checked': showCompletador }"
              @click="showCompletador = !showCompletador, showLector= false , showEditor= false">
            <span>{{ $t('completador') }}</span>
          </div>
        </div>
        <div class="d-flex gap-2">
          <button class="p-2 border-0 rounded-3 sombra fondo-terciario" @click="ponerEnLista()">
            <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="fill-principal">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9 6C9 4.34315 7.65685 3 6 3H4C2.34315 3 1 4.34315 1 6V8C1 9.65685 2.34315 11 4 11H6C7.65685 11 9 9.65685 9 8V6ZM7 6C7 5.44772 6.55228 5 6 5H4C3.44772 5 3 5.44772 3 6V8C3 8.55228 3.44772 9 4 9H6C6.55228 9 7 8.55228 7 8V6Z"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9 16C9 14.3431 7.65685 13 6 13H4C2.34315 13 1 14.3431 1 16V18C1 19.6569 2.34315 21 4 21H6C7.65685 21 9 19.6569 9 18V16ZM7 16C7 15.4477 6.55228 15 6 15H4C3.44772 15 3 15.4477 3 16V18C3 18.5523 3.44772 19 4 19H6C6.55228 19 7 18.5523 7 18V16Z"/>
              <path d="M11 7C11 6.44772 11.4477 6 12 6H22C22.5523 6 23 6.44772 23 7C23 7.55228 22.5523 8 22 8H12C11.4477 8 11 7.55228 11 7Z"/>
              <path d="M11 17C11 16.4477 11.4477 16 12 16H22C22.5523 16 23 16.4477 23 17C23 17.5523 22.5523 18 22 18H12C11.4477 18 11 17.5523 11 17Z"/>
            </svg>
          </button>
          <button class="p-2 border-0 rounded-3 sombra fondo-terciario" @click="ponerEnGrilla()">
            <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="fill-principal">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1C9.65685 1 11 2.34315 11 4V8C11 9.65685 9.65685 11 8 11H4C2.34315 11 1 9.65685 1 8V4C1 2.34315 2.34315 1 4 1H8ZM8 3C8.55228 3 9 3.44772 9 4V8C9 8.55228 8.55228 9 8 9H4C3.44772 9 3 8.55228 3 8V4C3 3.44772 3.44772 3 4 3H8Z"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 13C9.65685 13 11 14.3431 11 16V20C11 21.6569 9.65685 23 8 23H4C2.34315 23 1 21.6569 1 20V16C1 14.3431 2.34315 13 4 13H8ZM8 15C8.55228 15 9 15.4477 9 16V20C9 20.5523 8.55228 21 8 21H4C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15H8Z"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M23 4C23 2.34315 21.6569 1 20 1H16C14.3431 1 13 2.34315 13 4V8C13 9.65685 14.3431 11 16 11H20C21.6569 11 23 9.65685 23 8V4ZM21 4C21 3.44772 20.5523 3 20 3H16C15.4477 3 15 3.44772 15 4V8C15 8.55228 15.4477 9 16 9H20C20.5523 9 21 8.55228 21 8V4Z"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M20 13C21.6569 13 23 14.3431 23 16V20C23 21.6569 21.6569 23 20 23H16C14.3431 23 13 21.6569 13 20V16C13 14.3431 14.3431 13 16 13H20ZM20 15C20.5523 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H16C15.4477 21 15 20.5523 15 20V16C15 15.4477 15.4477 15 16 15H20Z"/>
            </svg>
          </button>
        </div>
      </div>


      <div class="container mb-4 mt-2">
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xxl-4 g-4" v-if="!verEnLista">
          <!-- Mostrar los formularios -->
          <div v-for="form in paginatedForms" :key="form.IdFormulario" @click="goToForm(form.IdFormulario)" style="cursor: pointer; z-index: 1">
            <div class="rounded-4 border-0 sombra d-flex flex-column card-hover-scale position-relative fondo-terciario" style="height: 100%;">
              <img v-if="form.PortadaUrl && !imagenError" :src="form.PortadaUrl" alt="Beneficios" class="rounded-top-4"
                style="height: 180px; width: 100%; object-fit: cover; object-position: center;" @error="imagenError = true">

              <div class="dropstart position-absolute top-0 end-0" @click.stop style="z-index: 2000">
                <button class="btn mt-2 me-2 fondo-terciario rounded-3 py-1 px-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <svg width="15" height="15" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(90deg); z-index: 900"  class="fill-principal">
                    <path d="M8 12C9.10457 12 10 12.8954 10 14C10 15.1046 9.10457 16 8 16C6.89543 16 6 15.1046 6 14C6 12.8954 6.89543 12 8 12Z"/>
                    <path d="M8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6Z"/>
                    <path d="M10 2C10 0.89543 9.10457 -4.82823e-08 8 0C6.89543 4.82823e-08 6 0.895431 6 2C6 3.10457 6.89543 4 8 4C9.10457 4 10 3.10457 10 2Z"/>
                  </svg>
                </button>
                <ul class="dropdown-menu fondo-terciario borde-secundario py-1 sombra-sm" style="z-index: 2000">
                  <li v-if="form.TipoPermiso == 'Editor'"><a class="dropdown-item texto-principal home-list" @click.stop="duplicarFormulario(form)">{{ $t('duplicar') }}</a></li>
                  <li v-if="form.TipoPermiso == 'Editor'"><hr class="w-100 my-0" /></li>
                  <li v-if="form.TipoPermiso == 'Editor'">
                    <a class="dropdown-item texto-principal home-list" @click.stop="habilitarFormulario(form)">
                      <span v-if="form.Habilitado == false">{{ $t('habilitar') }}</span>
                      <span v-if="form.Habilitado == true || form.Habilitado == null">{{ $t('deshabilitar') }}</span>
                    </a>
                  </li>
                  <li v-if="form.TipoPermiso == 'Editor'"><hr class="w-100 my-0" /></li>
                  <li v-if="form.TipoPermiso == 'Editor'"><router-link :to="'/formularios/edit?idForm=' + form.IdFormulario" class="dropdown-item texto-principal home-list">{{ $t('editar') }}</router-link></li>
                  <li v-if="form.TipoPermiso == 'Editor'"><hr class="w-100 my-0" /></li>
                  <li><router-link :to="'/formularios/completar?idForm=' + form.IdFormulario" class="dropdown-item texto-principal home-list">{{ $t('completar') }}</router-link></li>
                  <li><hr class="w-100 my-0" /></li>
                  <li><router-link :to="'/formularios/misRespuestas?idForm=' + form.IdFormulario" class="dropdown-item texto-principal home-list">{{ $t('misRespuestas') }}</router-link></li>
                </ul>
              </div>

              <div v-if="!form.PortadaUrl || imagenError" class="d-flex justify-content-center align-items-center fondo-terciario rounded-top-4" style="height: 200px;">
                <i class="bi bi-image fs-1 texto-secundario"></i>
              </div>
              <div class="text-center d-flex flex-column gap-3 justify-content-between p-3 pe-4">
                <div class="d-flex justify-content-between align-items-start">
                  <p class="text-truncate-2 fw-bold m-0 w-100">
                    {{ form.NombreFormulario }}
                  </p>
                </div>
                <div v-if="verTodosForms && showDetails">
                  <p class="m-0 fs-8 text-start">{{ $t('creadoPor') + ': ' + form.CreadorNombre }}</p>
                  <div class="d-flex flex-row justify-content-between">
                    <p class="m-0 texto-secundario fs-8">{{ $t('ultMod') + ': ' + formatDate(form.FechaModificacion) }}</p>
                    <p class="m-0 texto-secundario fs-8">{{ $t('creacion') + ': ' + formatDate(form.FechaCreacion) }}</p>
                  </div>
                </div>
              </div>
              <div v-if="form.Habilitado == false" class="black-overlay rounded-4" style="position: absolute; height: 100%; width: 100%; top: 0; left: 0;"></div>
            </div>
          </div>
        </div>
        <div class="row row-cols-1 g-4" v-if="verEnLista">
          <!-- Mostrar los formularios -->
          <div v-for="form in paginatedForms" :key="form.IdFormulario" @click="goToForm(form.IdFormulario)" style="cursor: pointer;">
            <div class="rounded-4 border-0 sombra d-flex flex-row card-hover-scale-sm position-relative align-items-center gap-2 fondo-terciario" style="height: 100%;">
              <img v-if="form.PortadaUrl && !imagenError" :src="form.PortadaUrl" alt="Beneficios" class="rounded-start-4 widthImg"
                style="height: 110px; object-fit: cover; object-position: center;" @error="imagenError = true">

              <div class="dropup-center position-absolute top-0 end-0" @click.stop style="z-index: 900">
                <button class="btn btn-sm m-2 fondo-terciario rounded-3" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                  <svg width="15" height="15" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(90deg); z-index: 900" class="fill-principal">
                    <path d="M8 12C9.10457 12 10 12.8954 10 14C10 15.1046 9.10457 16 8 16C6.89543 16 6 15.1046 6 14C6 12.8954 6.89543 12 8 12Z"/>
                    <path d="M8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6Z"/>
                    <path d="M10 2C10 0.89543 9.10457 -4.82823e-08 8 0C6.89543 4.82823e-08 6 0.895431 6 2C6 3.10457 6.89543 4 8 4C9.10457 4 10 3.10457 10 2Z"/>
                  </svg>
                </button>
                <ul class="dropdown-menu fondo-principal borde-secundario">
                  <li v-if="form.TipoPermiso == 'Editor'"><a class="dropdown-item texto-principal home-list" @click.stop="duplicarFormulario(form)">{{ $t('duplicar') }}</a></li>
                  <li v-if="form.TipoPermiso == 'Editor'"><hr class="w-100 my-0" /></li>
                  <li v-if="form.TipoPermiso == 'Editor'">
                    <a class="dropdown-item texto-principal home-list" @click.stop="habilitarFormulario(form)">
                      <span v-if="form.Habilitado == false">{{ $t('habilitar') }}</span>
                      <span v-if="form.Habilitado == true || form.Habilitado == null">{{ $t('deshabilitar') }}</span>
                    </a>
                  </li>
                  <li v-if="form.TipoPermiso == 'Editor'"><hr class="w-100 my-0" /></li>
                  <li v-if="form.TipoPermiso == 'Editor'"><router-link :to="'/formularios/edit?idForm=' + form.IdFormulario" class="dropdown-item texto-principal home-list">{{ $t('editar') }}</router-link></li>
                  <li v-if="form.TipoPermiso == 'Editor'"><hr class="w-100 my-0" /></li>
                  <li><router-link :to="'/formularios/completar?idForm=' + form.IdFormulario" class="dropdown-item texto-principal home-list">{{ $t('completar') }}</router-link></li>
                  <li><hr class="w-100 my-0" /></li>
                  <li><router-link :to="'/formularios/misRespuestas?idForm=' + form.IdFormulario" class="dropdown-item texto-principal home-list">{{ $t('misRespuestas') }}</router-link></li>
                </ul>
              </div>

              <div v-if="!form.PortadaUrl || imagenError" class="d-flex justify-content-center align-items-center fondo-terciario rounded-start-4" style="height: 110px; width: 180px;">
                <i class="bi bi-image fs-1 texto-secundario"></i>
              </div>
              <div class="text-center d-flex flex-column gap-3 justify-content-between p-3 pe-4">
                <div class="d-flex justify-content-between align-items-start">
                  <p class="text-truncate-2 fw-bold m-0 w-100 text-start">
                    {{ form.NombreFormulario }}
                  </p>
                </div>
                <div v-if="verTodosForms && showDetails">
                  <p class="m-0 fs-8 text-start">{{ $t('creadoPor') + ': ' + form.IdCreadorNavigation.Nombre + ' ' + form.IdCreadorNavigation.Apellido }}</p>
                  <div class="d-flex flex-row justify-content-between">
                    <p class="m-0 text-secondary fs-8">{{ $t('ultMod') + ': ' + formatDate(form.FechaModificacion) }}</p>
                    <p class="m-0 text-secondary fs-8">{{ $t('creacion') + ': ' + formatDate(form.FechaCreacion) }}</p>
                  </div>
                </div>
              </div>
              <div v-if="form.Habilitado == false" class="black-overlay rounded-4" style="position: absolute; height: 100%; width: 100%; top: 0; left: 0;"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="paginatedForms != null && paginatedForms.length == 0 && !loading" class="w-100">
        <p class="m-0 fs-6 text-center">{{ $t('noHayForms') }}</p>
      </div>

      <!-- Controles de Paginación --> 
      <nav aria-label="Page navigation" v-if="totalPages>1">
        <ul class="pagination m-0">
          <li class="p-2 rounded-start bg-goethe-accent-claro-3 borde-secundario border-1 border-end sombra" :class="{ disabled: currentPage === 1 }">
            <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="prevPage()">{{ $t('anterior') }}</a>
          </li>
          <li class="p-2 bg-goethe-accent-claro-3 borde-secundario sombra">
            <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="">{{ currentPage }} {{$t('de')}} {{ totalPages }}</a>
          </li>
          <li class="p-2 rounded-end bg-goethe-accent-claro-3 borde-secundario border-1 border-start sombra" :class="{ disabled: currentPage === totalPages }">
            <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="nextPage()">{{ $t('siguiente') }}</a>
          </li>
        </ul>
      </nav>

      <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
        <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
      </div>

    </div>
  </div>
</template>

<script>
  import { ref, computed, onMounted } from 'vue';
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  setup() {
    const { t } = useI18n();
    const search = ref('');
    const forms = ref([]);
    const allForms = ref([]);
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const loading = ref(false);
    const sortKey = ref('');
    const crearFormPermiso = ref(false);
    const mostrarTodos = ref(false);
    const showDetails = ref(false);
    const showMenuFilter = ref(false);
    const verTodosForms = ref(false);
    let verEnLista = ref(false);
    let imagenError = ref(false);
    

    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        var permisoAComprobar = 'VerFormularios'
        if(user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) ||
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
        permisoAComprobar = 'CrearFormularios'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          crearFormPermiso.value = true
        }
        permisoAComprobar = 'VerTodosForms'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          verTodosForms.value = true
        }
      }
    };

    const tieneAccesoEditor = ref(false);
    const tieneAccesoLector = ref(false);
    const tieneAccesoCompletador = ref(false);

    const showEditor = ref(false);
    const showLector = ref(false);
    const showCompletador = ref(false);

    const currentPage = ref(1);
    const itemsPerPage = ref(8); // Mostrar 2 formularios por página

    const totalPages = computed(() => {
      return Math.ceil(filteredForms.value.length / itemsPerPage.value);
    });

    const paginatedForms = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return filteredForms.value.slice(start, end);
    });

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++;
      }
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    const fetchForms = async () => {
      try {
        loading.value = true;
        let response;
        if(!mostrarTodos.value){
          response = await api.get(`api/Formularios/ByIdPersona`, {
            params: { id: user?.value.idPersona },
          });
          console.log('byID')
        } else {
          response = await api.get(`api/Formularios`);
          console.log('todos')
        }
        allForms.value = response.data;
        forms.value = response.data;
        loading.value = false;
        console.log(allForms.value)
        tieneAccesoEditor.value = allForms.value.some(formulario => 
          formulario.TipoPermiso == "Editor"
        );

        tieneAccesoLector.value = allForms.value.some(formulario => 
          formulario.TipoPermiso == "Lector"
        );

        tieneAccesoCompletador.value = allForms.value.some(formulario => 
          formulario.TipoPermiso == "Completador"
        );
      } catch (error) {
        loading.value = false;
        console.error('Error al obtener formularios:', error);
      }
    };

    const filteredForms = computed(() => {
      function normalizeString(str) {
        if (!str) return ''; // Si str es null, undefined o vacío, retorna una cadena vacía
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      }

      const searchParts = search.value?.trim().toLowerCase().split(/\s+/) || [];

      //Filtra por tipo de Acceso
      let tipo = showEditor.value ? "Editor" : showLector.value ? "Lector" : showCompletador.value ? "Completador" : null;

      let type = forms.value;
      if (tipo) {
        type = forms.value.filter(formulario =>
          formulario.TipoPermiso == tipo
        );
      }


      const result = type.filter(form => {
        const nombre = normalizeString(form.NombreFormulario ?? '');

        // Verifica que cada parte de la búsqueda coincida en algún campo
        return searchParts.every(part =>
          nombre.includes(normalizeString(part))
        );
      });

      // Ordena los formularios según el sortKey
      if (sortKey.value) {
        result.sort((a, b) => {
          let modifier = 1;
          if (sortKey.value === 'Titulo') {
            return modifier * a.NombreFormulario.localeCompare(b.NombreFormulario);
          } else if (sortKey.value === 'CreadoPor') {
            const creatorA = `${a.IdCreadorNavigation.Nombre} ${a.IdCreadorNavigation.Apellido}`;
            const creatorB = `${b.IdCreadorNavigation.Nombre} ${b.IdCreadorNavigation.Apellido}`;
            return modifier * creatorA.localeCompare(creatorB);
          } else if (sortKey.value === 'Creacion') {
            return -1 * (new Date(a.FechaCreacion) - new Date(b.FechaCreacion));
          } else if (sortKey.value === 'UltMod') {
            return -1 * (new Date(a.FechaModificacion) - new Date(b.FechaModificacion));
          }
          return 0;
        });
      }
      
      return result;
    });


    const duplicarFormulario = async (form) => {
      try {
        const response = await api.post(`api/Formularios/Duplicar`,
          {}, // body vacío
          {
            params: { id: form.IdFormulario },
          }
        );


        if (response.status === 202 || response.status === 200) {
          console.log('Formulario duplicado con éxito');
          fetchForms(); // actualiza la lista
        } else {
          console.warn('No se pudo duplicar el formulario:', response.status);
        }
      } catch (error) {
        console.error('Error al duplicar el formulario:', error);
      }
    }

    const habilitarFormulario = async (form) => {
      try {
        const response = await api.put(`api/Formularios/Habilitar`,
          {}, // body vacío
          {
            params: { 
              idForm: form.IdFormulario,
              habilitado: !form.Habilitado
            },
          }
        );

        if (response.status === 202 || response.status === 200) {
          console.log('Formulario habilitado con éxito');
          fetchForms(); // actualiza la lista
        } else {
          console.warn('No se pudo habilitar el formulario:', response.status);
        }
      } catch (error) {
        console.error('Error al habilitar el formulario:', error);
      }
    }


    const formatDate = (date) => {
      return new Date(date).toLocaleDateString('es-ES', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
      });
    };

    const editForm = (id) => {
      alert(`Editar formulario con ID: ${id}`);
    };

    const permisoEditar = (form) => {
      return form.AccesoFormularios.find(acceso => (acceso.IdPersona === user?.value.idPersona || acceso.IdOpcionGrupoNavigation?.PersonasRelacionadas?.some(pr => pr.IdPersona == user?.value.idPersona)) && acceso.TipoPermiso == "Editor" ) || form.IdCreador == user?.value.idPersona;
    };

    const goToForm = async (idFormulario) => {
      let resultForm = forms.value.find((form) =>
        form.IdFormulario.toLowerCase().includes(idFormulario.toLowerCase())
      );
      console.log(resultForm)
      console.log(resultForm.TipoPermiso)
      if (resultForm.TipoPermiso == "Lector" || resultForm.TipoPermiso == "Editor"){
        await router.push(`/formularios/ver?idForm=${idFormulario}`);
      }
      else if (resultForm.TipoPermiso == "Completador") {
        await router.push(`/formularios/misRespuestas?idForm=${idFormulario}`);
      }
    };

    const ponerEnGrilla = () => {
      verEnLista.value=false;
      localStorage.setItem('verEnLista', false);
    };

    const ponerEnLista = () => {
      verEnLista.value=true;
      localStorage.setItem('verEnLista', true);
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      localStorage.setItem('idForm', '');
      checkAuth();
      fetchForms();

      verEnLista.value = localStorage.getItem("verEnLista") === "true";
    });

    return {
      search,
      forms,
      filteredForms,
      formatDate,
      editForm,
      loading,
      goToForm,
      sortKey,
      crearFormPermiso,
      t,
      currentPage,
      itemsPerPage,
      totalPages,
      paginatedForms,
      nextPage,
      prevPage,
      mostrarTodos,
      fetchForms,
      verTodosForms,
      showDetails,
      showMenuFilter,
      tieneAccesoEditor,
      tieneAccesoLector,
      tieneAccesoCompletador,
      showEditor,
      showLector,
      showCompletador,
      permisoEditar,
      duplicarFormulario,
      verEnLista,
      ponerEnLista,
      ponerEnGrilla,
      imagenError,
      habilitarFormulario,
    };
  },
};
</script>

<style scoped>
.btn-floating {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 900;
  background-color: #006330;
  color: #ffffff;
}
.creacionColumn{
  display: none;
}
.checkbox-custom {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 30px;
  height: 18px;
  background-color: #e0e0e0;
  border-radius: 50px;
  position: relative;
  transition: background-color 0.3s ease;
  cursor: pointer;
  border: 2px solid transparent;
}
@media (min-width: 768px) {
  .creacionColumn{
    display: table-cell;
  }
}

</style>
